import { useState } from "react";
import { Link } from "react-router-dom";
import { useScrollFadeIn } from "@/hooks/useScrollFadeIn";

const playItems = [
  "フェチ",
  "ペニバン",
  "変態的要素のあるプレイ全般",
  "スパンキング（ディシプリンを含む）",
  "フェザータッチ",
  "精神的な支配",
  "ハンドジョブ / ルーインドコントロール",
  "その他、性癖を用いたコミュニケーション",
];

const extraPlayItems = [
  "アナルプレイ",
  "顔面騎乗",
  "乳首責め",
  "手コキ",
  "射精管理",
  "亀頭責め",
  "ローションストッキング",
  "潮吹き",
  "唾液責め",
  "くすぐり",
  "ストーリープレイ",
  "M格闘",
];

const ngItems = [
  "本番行為",
  "フェラチオ",
  "トップレス",
  "嘔吐・過度な飲酒を伴う行為",
];

export default function SessionSection() {
  const [expanded, setExpanded] = useState(false);
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>();
  const { ref: card1Ref, style: card1Style } = useScrollFadeIn<HTMLDivElement>({ delay: 0.05 });
  const { ref: card2Ref, style: card2Style } = useScrollFadeIn<HTMLDivElement>({ delay: 0.05 });

  return (
    <section id="session" className="py-20 md:py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-10">

        {/* ヘッダー */}
        <div ref={headRef} style={headStyle} className="text-center mb-8 md:mb-10">
          <h2 className="font-en text-3xl md:text-4xl font-normal text-stone-800 tracking-widest">
            Session Contents
          </h2>
          <div className="w-12 h-0.5 bg-amber-400 mx-auto mt-4 mb-5 md:mt-5 md:mb-6"></div>

          {/* PC版: 2行 */}
          <p className="hidden md:block text-sm text-stone-400 leading-loose tracking-wide mx-auto">
            むぎ茶のセッションは、SM・M性感をベースにした完全プライベートな体験です。<br />
            あなたの性癖・フェチ・好奇心に合わせて、二人だけのプレイを丁寧に構築します。
          </p>
          {/* スマホ版: 指定の改行 */}
          <p className="md:hidden text-[13px] text-stone-400 leading-[2] tracking-wide mx-auto">
            むぎ茶のセッションは、SM・M性感をベースにした<br />
            完全プライベートな体験です。<br />
            あなたの性癖・フェチ・好奇心に合わせて<br />
            二人だけのプレイを丁寧に構築します。
          </p>

          <p className="mt-4 md:mt-3 text-[11px] md:text-sm text-stone-400 tracking-wider">
            ※ 初めての方・SM未経験の方も大歓迎です
          </p>
        </div>

        {/* セッション内容カード */}
        <div ref={card1Ref} style={card1Style} className="bg-stone-50 p-4 md:p-7 border border-stone-200 mb-3 md:mb-4">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-heart-line text-amber-600 text-base"></i>
            </div>
            <h3 className="text-[13px] md:text-sm tracking-[0.2em] text-stone-700 font-medium">
              SM・M性感プレイメニュー
            </h3>
          </div>

          {/* Desktop: 2列グリッド */}
          <ul className="hidden sm:grid grid-cols-2 gap-x-5 gap-y-2">
            {playItems.map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-stone-600">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-1.5 flex-shrink-0"></span>
                {item}
              </li>
            ))}
          </ul>

          {/* Mobile: タグ形式 */}
          <ul className="sm:hidden flex flex-wrap gap-2">
            {playItems.map((item, i) => (
              <li
                key={i}
                className="px-3.5 py-2 bg-amber-50/90 border border-amber-300/50 text-[12px] text-stone-700 tracking-wide leading-tight rounded-lg"
              >
                {item}
              </li>
            ))}
          </ul>

          {/* 追加コンテンツ（展開） */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              expanded ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <div className="border-t border-stone-200 mt-4 pt-4">
              <ul className="hidden sm:grid grid-cols-2 gap-x-5 gap-y-2">
                {extraPlayItems.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-stone-600">
                    <span className="w-1.5 h-1.5 rounded-full bg-amber-300 mt-1.5 flex-shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
              <ul className="sm:hidden flex flex-wrap gap-2">
                {extraPlayItems.map((item, i) => (
                  <li
                    key={i}
                    className="px-3.5 py-2 bg-amber-50/60 border border-amber-200/50 text-[12px] text-stone-500 tracking-wide leading-tight rounded-lg"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* トグルボタン */}
          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-6 flex items-center gap-2 text-sm text-amber-700 active:text-amber-900 transition-colors cursor-pointer whitespace-nowrap px-4 py-2.5 rounded-lg active:bg-amber-50 active:scale-[0.97]"
          >
            <span className="font-medium">{expanded ? "閉じる" : "さらに見る"}</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i
                className={`ri-arrow-down-s-line text-base transition-transform duration-300 ${
                  expanded ? "rotate-180" : ""
                }`}
              ></i>
            </div>
          </button>
        </div>

        {/* NG行為カード */}
        <div ref={card2Ref} style={card2Style} className="px-5 py-5 border border-stone-200 bg-white rounded-lg">
          <div className="flex items-center gap-2.5 mb-3.5">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-close-circle-line text-stone-300 text-base"></i>
            </div>
            <h3 className="text-[12px] tracking-[0.25em] text-stone-400 font-medium uppercase">
              NG行為
            </h3>
          </div>
          <ul className="flex flex-wrap gap-2">
            {ngItems.map((item, i) => (
              <li
                key={i}
                className="px-3.5 py-2 bg-white border border-stone-200 text-[12px] text-stone-400 tracking-wide leading-tight rounded-lg"
              >
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-3.5 text-[12px] text-stone-300 leading-relaxed">
            上記以外でも、相応しくないと判断した場合はお断りする場合がございます。
          </p>
        </div>

        {/* 予約ボタン */}
        <div className="mt-10 text-center">
          <Link
            to="/how-to-book"
            className="flex sm:inline-flex items-center justify-center gap-3 w-full sm:w-auto px-10 py-4 bg-stone-800 text-white text-[15px] tracking-[0.2em] font-medium active:bg-amber-700 transition-all duration-200 cursor-pointer whitespace-nowrap rounded-lg active:scale-[0.97]"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line text-base"></i>
            </div>
            ご予約はこちら
          </Link>
        </div>

      </div>
    </section>
  );
}